import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const FilterContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const PeriodFilter = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 428px;
  p {
    white-space: nowrap;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  gap: 40px;
`;

export const Skeleton = styled.div`
  animation: skeleton 2s ease-in-out 0.5s infinite;
  border-radius: 8px;
`;

